import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column gr-6",
      class: { "px-2 py-6": _setup.isMobile },
    },
    [
      _c(
        "a",
        {
          staticClass:
            "d-inline-flex align-center gc-2 primary--text text-decoration-none align-self-start",
          attrs: {
            href: _setup.reverseFull({ name: "ethical_commission" }),
            text: "",
          },
        },
        [
          _c("span", { staticClass: "ui-icon-arrow-back" }),
          _vm._v(" "),
          _c("span", { staticClass: "text-body-1" }, [
            _vm._v(_vm._s(_setup.t("Назад", _setup.options))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "d-flex flex-column gr-6" },
        _vm._l(
          _vm.ethicalCommissionMeetings,
          function (ethicalCommissionMeeting, index) {
            return _c("div", { key: index }, [
              _vm.isStaff && !_setup.isMobile
                ? _c(
                    "a",
                    {
                      staticClass:
                        "adminka mx-0 mb-2 pa-1 d-inline-block text-body-2",
                      attrs: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                        href: _setup.reverseFull({
                          name: "admin:info_ethicalcommissionmeeting_change",
                          args: [ethicalCommissionMeeting.id],
                        }),
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.t("Править заседание", _setup.options)
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-center" },
                [
                  _c("div", { staticClass: "text-h6 text--text mb-2" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_setup.t("Заседание", _setup.options)) +
                        " " +
                        _vm._s(ethicalCommissionMeeting.meeting_number) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  ethicalCommissionMeeting.protocol && _setup.isMobile
                    ? _c(
                        _setup.CorePRG,
                        {
                          staticClass: "ml-auto",
                          attrs: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "button-attrs": {
                              class: "primary--text link-decoration-none",
                            },
                            url: ethicalCommissionMeeting.protocol,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.t("Протокол", _setup.options)) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "text-body-2 text-secondary--text d-flex align-center gc-7 mb-4",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(ethicalCommissionMeeting.meeting_date)),
                  ]),
                  _vm._v(" "),
                  _c("span", { class: { "ml-auto": _setup.isMobile } }, [
                    _vm._v(
                      _vm._s(
                        _setup.t("Количество присутствующих:", _setup.options)
                      ) +
                        " " +
                        _vm._s(ethicalCommissionMeeting.number_of_present)
                    ),
                  ]),
                  _vm._v(" "),
                  ethicalCommissionMeeting.protocol && !_setup.isMobile
                    ? _c(
                        _setup.CorePRG,
                        {
                          staticClass: "ml-auto",
                          attrs: {
                            target: "_blank",
                            rel: "noopener noreferrer",
                            "button-attrs": {
                              class: "primary--text link-decoration-none",
                            },
                            url: ethicalCommissionMeeting.protocol,
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.t("Протокол", _setup.options)) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex flex-column gr-6 elevation-1 rounded-sm",
                  class: _setup.isMobile ? "pa-4" : "pa-6",
                },
                [
                  _vm._l(
                    ethicalCommissionMeeting.cases.all,
                    function (meetingCase, meetingCaseIndex) {
                      return [
                        meetingCaseIndex !== 0
                          ? _c(VDivider, {
                              key: `divider-${meetingCaseIndex}`,
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(_setup.MeetingCard, {
                          key: `meeting-case-${meetingCase.id}`,
                          attrs: {
                            "is-staff": _vm.isStaff,
                            "meeting-case": meetingCase,
                          },
                        }),
                      ]
                    }
                  ),
                ],
                2
              ),
            ])
          }
        ),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }